import { Report } from "components/reports/Report";
import { ReportSubscriptionContextProvider } from "components/reports/ReportSubscriptionProvider";
import { useReportConfig } from "lib/hooks/api/reports/useReportConfig";
import UTMParamsProvider from "lib/providers/UTMParams";

/**
 * Print view of a report, rendered by the TanStack Router print route. The PDF
 * export flow navigates a headless browser here; `pdfToken` (a short-lived
 * signed token) grants access to a private report's config without a session.
 */
export function PrintReportPage({
  reportId,
  pdfToken,
}: {
  reportId: string;
  pdfToken?: string;
}): JSX.Element | null {
  const { data: report, isLoading } = useReportConfig(reportId, pdfToken);

  if (isLoading || !report) {
    return null;
  }

  return (
    <UTMParamsProvider utmParams={{ source: "pdf", campaign: report.id, medium: "report" }}>
      <ReportSubscriptionContextProvider>
        <Report report={report} />
      </ReportSubscriptionContextProvider>
    </UTMParamsProvider>
  );
}
